<template lang="html">
  <div class="edit-site-gtm tier tier-three">
    <Tooltip
      content="Connect your GTM account to easily manage tags"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs :headings="['Your GTM ID', 'Connect Account']">
        <Tab>
          <div>
            <SiteGtmForm
              @submit="submitSite"
              v-model="site"
              :errors="errors"
            />
          </div>
        </Tab>

        <Tab>
          <div>
            <p>
              Manage all your tags without editing code. Google Tag Manager delivers simple, reliable, easily integrated tag management – for free.
            </p>

            <hr />

            <h3>How to connect</h3>

            <div class="helper-text">
              Simply head over to <a href="https://tagmanager.google.com/#/home">https://tagmanager.google.com/</a>, create an account and paste your <strong>Container ID</strong> in the <strong>Your GTM ID</strong> tab.
            </div>

            <hr />

            <p>Need a hand? Feel free to <a href="/contact">Contact us</a>.</p>
          </div>
        </Tab>
      </Tabs>

      <router-view />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteGtmForm from '@/components/forms/SiteGtmForm'
import Tooltip from '@/components/Tooltip'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

export default {
  name: 'EditSiteGtm',

  components: {
    SiteGtmForm,
    Tooltip,
    Tabs,
    Tab
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} GTM Settings`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Container ID updated!`
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'GTM Container ID', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
